import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { ASSETS } from "../lib/content";

export const Martini = () => (
  <section id="martini" data-testid="martini-section" className="px-5 md:px-10 py-14 md:py-20">
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="max-w-[1400px] mx-auto"
    >
      <Link
        to="/recipes"
        data-testid="martini-recipes-banner"
        className="group relative block overflow-hidden rounded-lg border border-white/10 hover:border-ember/60 transition-colors"
      >
        <img
          src={ASSETS.martini}
          alt="Espresso martini"
          className="absolute inset-0 w-full h-full object-cover opacity-35 transition-all duration-700 group-hover:opacity-45 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-void/90 via-void/60 to-transparent" />
        <div className="relative px-6 py-10 md:px-12 md:py-14 flex flex-col md:flex-row md:items-center gap-6 md:gap-10">
          <div className="flex-1">
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-ember mb-3">After Dark</p>
            <h2 className="font-display font-black uppercase tracking-tight text-cream text-3xl md:text-5xl leading-[0.95]">
              The espresso martini, <span className="font-serif italic font-normal lowercase text-ember whitespace-nowrap">gremlin-ified</span>
            </h2>
            <p className="font-mono text-sm text-cream/75 mt-4 max-w-lg leading-relaxed">
              Brew the flavor straight into the drink. Chocolate-whiskey martinis, coconut cold brew and more in the Recipe Hub.
            </p>
          </div>
          <span className="shrink-0 inline-flex items-center gap-3 bg-ember text-void font-mono uppercase text-xs tracking-widest px-7 py-4 rounded-full font-medium group-hover:bg-emberDark transition-colors">
            Get the recipes <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
          </span>
        </div>
      </Link>
    </motion.div>
  </section>
);
